
import Vue from 'vue'
import ConfirmCheckbox from '@/components/ConfirmCheckbox.vue'
import EmailValidation from '@/service/EmailValidation'

export default Vue.extend({
  name: 'Newsletter',
  components: {
    ConfirmCheckbox,
  },
  mounted() {
    this.fetchTerms()
  },
  watch: {
    termsAndConditions(val){
      if (val && window.location.hash === '#newsletter') {
        this.$store.dispatch(
          'alert/warning',
          'Newsletter activation link have expired, subscribe again.'
        );

        this.$nextTick(() => {
          setTimeout(() => {
            const element = document.getElementById('newsletter');
            if (element) {
              const y = element.getBoundingClientRect().top + window.scrollY - 100;
              window.scrollTo({
                top: y,
                behavior: 'smooth'
              });
            }
          }, 300);
        });
      }
    }
  },
  data: () => ({
    confirmSubscriptionDialog: false,
    termsAndConditions: null as string | null,
    emailRules: [
      (v: string) => !!v || 'E-mail is required.',
      (v: string) =>
        EmailValidation.isValid(v) || 'Enter correct e-mail address.',
    ],
    email: '',
    subscriptionSaveLoading: false,
  }),
  methods: {
    fetchTerms: function () {
      this.$api
        .get('/contents/static/newsletter')
        .then((response) => (this.termsAndConditions = response.data.newsletter))
    },
    showConfirmSubscriptionDialog: function () {
      this.confirmSubscriptionDialog = true
    },
    resetNewsletterForm: function () {
      this.email = ''
      ;(this.$refs.newsletterFormRef as any).resetValidation()
    },
    confirmLongTextInput: function (value: boolean) {
      if (!value) {
        this.resetNewsletterForm()
      }
    },
    subscribe: async function () {
      this.subscriptionSaveLoading = true
      await this.$recaptchaLoaded()
      const token = await this.$recaptcha('newsletter')
      this.$api
        .post('/newsletter', { email: this.email, token: token })
        .then(() => {
          this.$store.dispatch(
            'alert/success',
            'Thanks for subscribing our newsletter. Check your inbox for the verification e-mail.'
          )
        })
        .catch(() => {
          this.$store.dispatch(
            'alert/error',
            'There was an error signing to a newsletter. If you have already tried to sign in, check out your inbox for the verification e-mail.'
          )
        })
        .finally(() => {
          this.subscriptionSaveLoading = false
          this.confirmSubscriptionDialog = false
          this.resetNewsletterForm()
          ;(this.$refs as any).confirmCheckboxDialog.resetForm()
        })
    },
  },
})
